import { PhaseChangeEvent as SrvgPhaseChangeEvent, Phase } from "@gaming/srvg-classes-core";
import { Chunk } from "../Data/Chunk";


/**
 * Represents the change to another phase, or to an entirely other matchday.
 */
export class PhaseChangeEvent extends SrvgPhaseChangeEvent {
    /**
     * The channel for which this data is relevant.
     */
    channel: number;
    /**
     * The new current chunk.
     */
    chunk: Chunk;

    /**
     * Datetime of the server, to calculate phases and so on
     */
    serverDatetime: number;

    /**
     * Creates an instance of this class.
     * @param matchday The new current match day.
     * @param season The new current season.
     * @param phase The new current phase.
     */
    constructor( channel: number, chunk: Chunk, phase?: Phase, serverDatetime?: number ) {
        super( phase );
        this.channel = channel;
        this.chunk = chunk;
        this.serverDatetime = serverDatetime || null;
    }

    /**
     * Returns the string that is used to compare event types and construct handler method names. Every instance
     * has this string stored in the eventType property.
     */
    static getEventType() {
        return 'phaseChangeEvent';
    }

    /**
     * Cleanup code belongs here. Please note that this method is _NOT_ called automatically yet.
     */
    destroy() {
        this.chunk = null;
        super.destroy();
    }
}